import { render } from "./Index.vue?vue&type=template&id=0ced42ad&scoped=true"
import script from "./Index.vue?vue&type=script&lang=js"
export * from "./Index.vue?vue&type=script&lang=js"

import "./Index.vue?vue&type=style&index=0&id=0ced42ad&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-0ced42ad"

export default script